import React from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import InputBase from "@material-ui/core/InputBase";

// styles
import useStyles from "./styles";

// pictures
import GLabLogoFooter from "../../images/logo.svg";
import GLabBadge from "../../images/lab-badge.png";


export default function Footer() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Container maxWidth="lg">
        <Grid container className={classes.footerPos}>
          <Grid item xs={2} className={classes.logo}>
            <img
              src={GLabLogoFooter}
              height={43}
              alt="guinsoo-logo-footer"
            />
            <img src={GLabBadge} height={60} width={60} alt="badge" />
          </Grid>
          <Grid item xs={10} >
            <Grid container alignItems={"stretch"} justify="center" spacing={1}>
              <Grid item xs={2} className={classes.footerBody}>
                <b className={classes.title2}>Why Venus</b>
                <b className={classes.titleX}>Discover</b>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>For Executives</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>For Startups</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>LakeHouse Architecture</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Data + AI Research</p>
                <b className={classes.titleX}>Customers</b>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Customer Stories</p>
                <b className={classes.titleX}>Partners</b>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Cloud Providers</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Technology Providers</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Data Providers</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Partner Solutions</p>
              </Grid>
              <Grid item xs={2} className={classes.footerBody}>
                <b className={classes.title2}>Product</b>
                <b className={classes.titleX}>Venus Platform</b>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Platform Overview</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Sharing</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Governance</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Artificial Intelligence</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Business Intelligence</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Database</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Data Management</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Data Warehousing</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Data Engineering</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Data Science</p>
                <b className={classes.titleX}>Integrations & Data</b>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Marketplace</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>IDE Integrations</p>
              </Grid>
              <Grid item xs={2} className={classes.footerBody}>
                <b className={classes.title2}>Solutions</b>
                <b className={classes.titleX}>Venus For Industries</b>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Communications</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Financial Services</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Healthcare & Life Science</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Manufacturing</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Media & Entertainment</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Public Sector</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Retail</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Others</p>
              </Grid>
              <Grid item xs={2} className={classes.footerBody}>
                <b className={classes.title2}>Resources</b>
                <b className={classes.titleX}>Learning</b>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Documentation</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Tutorials</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Webinars</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Blog</p>
                <b className={classes.titleX}>Support</b>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Contact Support</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Knowledge Center</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>System Status</p>
              </Grid>
              <Grid item xs={2} className={classes.footerBody}>
                <b className={classes.title2}>About</b>
                <b className={classes.titleX}>Company</b>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>About Venus</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Leadership</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Careers</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Newsroom</p>
                <p className={classes.bodyX} onClick={() => window.open("https://docs.data.labillion.cn/venus", "_blank")}>Events</p>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={0} className={classes.footerBody2}>
                  <Grid item xs={3} className={classes.title22}>Subscribe for Venus</Grid>
                  <Grid item xs={9}>
                    <InputBase fullWidth className={classes.input} placeholder={"Enter email address"} />
                  </Grid>
                  <Grid item xs={12} className={classes.submitButton}>
                    <Button className={classes.button}>Subscribe</Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        {/* divider */}
        <Divider className={classes.appDivider} />
        {/* copyright */}
        <Grid container className={classes.copyright}>
          <Grid item xs={12}>
            <p>© Megarobo x LABILLION. All right reserved.</p>
          </Grid>
          <Grid item xs={12}>
            <p>LABILLION, Mega, MegaLab, and the Venus feather logo are either
              registered trademarks or trademarks of the MegaRobo.<br/> All other products or name
              brands are trademarks of their respective holders, including the MegaRobo, and
              Mega resources.
            </p>
          </Grid>
          <Grid item xs={12} className={classes.footerItem}>
            <p>
              <span onClick={() => window.open("https://github.com/OpenMegaLab", "_blank")}>Security</span>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <span onClick={() => window.open("https://github.com/OpenMegaLab", "_blank")}>Donate</span>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <span onClick={() => window.open("hhttps://github.com/OpenMegaLab", "_blank")}>Thanks</span>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <span onClick={() => window.open("https://github.com/OpenMegaLab", "_blank")}>Events</span>
              &nbsp;&nbsp;|&nbsp;&nbsp;
              <span onClick={() => window.open("https://github.com/OpenMegaLab", "_blank")}>License</span>
            </p>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}